module.exports = __webpack_public_path__ + "static/media/Inter-Black.5a11c247.eot";